import { Component, OnInit, AfterViewInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  standalone: true,
  imports: [CommonModule],

  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  constructor(
    private router: Router,
    private _activatedRoute: ActivatedRoute
  ) {}
  parameterValue: string;
  href;

  ngOnInit() {
    this.href=window.location.href.substring(window.location.href.lastIndexOf('/') + 1)

    if(this.href==""){
      this.parameterValue = "/";
    }
    else if (this.href == 'individual'){
      this.parameterValue = 'individual';
    }

    else if(this.href=='aboutus'){
      this.parameterValue = 'aboutus';
    }

    
    else if(this.href=='blog'){
      this.parameterValue = 'blog';
    }

    else if(this.href=='contactus'){
      this.parameterValue = 'contactus';
    }

  
  }

  onSwitchPage(e) {


      if (e == "individual"){
        this.parameterValue = 'individual';
        this.router.navigate(["individual"]);  
      }

      else if(e=='business'){
        this.parameterValue = '/';
        this.router.navigate([""])
      }
     
  }
}
